import { z } from "zod";

import { FindReplaceSchema } from "../../../schemas/find-replaces";

export const PutCampaignFindReplacesRequestBodySchema =
  FindReplaceSchema.array();

export type PutCampaignFindReplacesRequestBodyType = z.infer<
  typeof PutCampaignFindReplacesRequestBodySchema
>;

export const PutCampaignFindReplacesResponseBodySchema = z.object({
  findReplaces: FindReplaceSchema.array(),
});

export type PutCampaignFindReplacesResponseBodyType = z.infer<
  typeof PutCampaignFindReplacesResponseBodySchema
>;
